// extracted by mini-css-extract-plugin
export default {"icon":"BackgroundPicker_icon__3bRKw","picker":"BackgroundPicker_picker__LU-ZB","pickerItem":"BackgroundPicker_pickerItem__giD1J"};